import { jsx as _jsx } from "react/jsx-runtime";
import CheckIcon from '@heroicons/react/outline/CheckIcon';
import LockClosedIcon from '@heroicons/react/outline/LockClosedIcon';
import { useNetwork } from '@tribeplatform/react-sdk/hooks';
import { Badge } from '@tribeplatform/react-ui-kit/Badge';
import { useStaticIntl } from '../../i18n';
import { getTranslatedPlanName } from '../../utils/plan';
export const PlanBadge = (props) => {
    const { requiredPlanName, authorized, size = 'lg' } = props;
    const planName = useStaticIntl(getTranslatedPlanName, requiredPlanName);
    const { data: network } = useNetwork();
    const plan = network === null || network === void 0 ? void 0 : network.subscriptionPlan;
    if (authorized && !(plan === null || plan === void 0 ? void 0 : plan.trial)) {
        return null;
    }
    return (_jsx(Badge, { leadingIcon: authorized ? _jsx(CheckIcon, {}, void 0) : _jsx(LockClosedIcon, {}, void 0), size: size, variant: authorized ? 'primary' : 'secondary', ...props, children: planName }, void 0));
};
//# sourceMappingURL=PlanBadge.js.map